export const DOWNLOAD_DOCUMENT = 'DOWNLOAD_DOCUMENT';
export const downloadDocument = (documentType, documentIds, templateId, providedDownloadUrl) => {
  return {
    type: DOWNLOAD_DOCUMENT,
    documentType,
    documentIds,
    templateId,
    providedDownloadUrl,
  };
};

export const PRINT_DOCUMENT = 'PRINT_DOCUMENT';
export const printDocument = (documentType, documentIds, printSetting, templateId, printUrl) => {
  return {
    type: PRINT_DOCUMENT,
    documentType,
    documentIds,
    printSetting,
    templateId,
    printUrl,
  };
};
